export function startTimingLog(key) {
	if (window && window.localStorage) {
		if (localStorage.getItem('ansyn-logTimerOn')) {
			console.time(key);
		}
	}
}

export function endTimingLog(key) {
	if (window && window.localStorage) {
		if (localStorage.getItem('ansyn-logTimerOn')) {
			console.timeEnd(key);
		}
	}
}



// WEBPACK FOOTER //
// C:/Users/user/projects/ansyn/src/app/packages/core/utils/logs/timer-logs.ts